import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// BÉR – Bér adatszolgáltatás: a /api/ber-adatszolg router (backend/ber-adatszolg.js) hívásai. Az
// aktív ügyfél, év és hónap a BerService-ből jön; ez a végpontokat, a CSV-t és a hibaüzenetet adja.
@Injectable({ providedIn: 'root' })
export class AdatszolgApi {
  private readonly base = '/api/ber-adatszolg';

  constructor(private http: HttpClient) {}

  get<T = any>(ut: string): Promise<T> { return firstValueFrom(this.http.get<T>(this.base + ut)); }
  put<T = any>(ut: string, body: any): Promise<T> { return firstValueFrom(this.http.put<T>(this.base + ut, body)); }

  hibaUzenet(e: any, tartalek = 'Hiba történt.'): string { return e?.error?.error || tartalek; }
}

/** Forint egészre, magyar ezres tagolással (a képernyő `number:'1.0-0'` párja nyomtatáshoz). */
export function ftSzoveg(v: any): string {
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n).toLocaleString('hu-HU') : '';
}

/** Szám a CSV-be: egész forint pont nélkül, törtnél tizedesvessző (a magyar Excel így olvassa). */
function csvSzam(v: number): string {
  const k = Math.round(v * 100) / 100;
  return Number.isInteger(k) ? String(k) : String(k).replace('.', ',');
}

/** CSV letöltése (pontosvessző, UTF-8 BOM – a magyar Excel így nyitja meg jól). */
export function csvLetolt(fajlnev: string, fejlec: string[], sorok: any[][]): void {
  const cella = (v: any) => {
    if (v == null) return '';
    if (typeof v === 'number') return csvSzam(v);
    const s = String(v);
    return /[;"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [fejlec, ...sorok].map((r) => r.map(cella).join(';')).join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fajlnev;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export const HONAPNEV = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];

/** Évlista a választókhoz (a jövő év és négy múltbeli). */
export function evLista(): number[] { const e = new Date().getFullYear(); return [e + 1, e, e - 1, e - 2, e - 3, e - 4]; }
